import { HttpParams } from '@angular/common/http';

export type SortDirection = 'asc' | 'desc';

export type Sort = {
  field: string;
  direction: SortDirection;
};

export type PageRequest = {
  page: number;
  size: number;
  sort?: Sort[];
};

export type PageResponse<T> = {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
};

export const DEFAULT_PAGE_SIZE = 10;

export function firstPage(size = DEFAULT_PAGE_SIZE, sort?: Sort[]): PageRequest {
  return { page: 0, size, sort };
}

export function emptyPage<T>(size = DEFAULT_PAGE_SIZE): PageResponse<T> {
  return { content: [], page: 0, size, totalElements: 0, totalPages: 0, last: true };
}

export function toPageParams(request: PageRequest, params = new HttpParams()): HttpParams {
  let next = params.set('page', request.page).set('size', request.size);
  for (const sort of request.sort ?? []) {
    next = next.append('sort', `${sort.field},${sort.direction}`);
  }
  return next;
}

export function toClientPage<T>(items: T[], request: PageRequest): PageResponse<T> {
  const start = request.page * request.size;
  const totalPages = Math.ceil(items.length / request.size);
  return {
    content: items.slice(start, start + request.size),
    page: request.page,
    size: request.size,
    totalElements: items.length,
    totalPages,
    last: request.page >= totalPages - 1,
  };
}
